import { createContext, useContext } from 'react';

export interface LayoutContext {
  isLeftSidebarOpen: boolean;
  setIsLeftSidebarOpen: (newVal: boolean) => void;
  toggleLeftSidebar: (newVal?: boolean) => void;
  isRightSidebarOpen: boolean;
  setIsRightSidebarOpen: (newVal: boolean) => void;
  toggleRightSidebar: (newVal?: boolean) => void;
  activeExplorationSourceId: string | null;
  setActiveExplorationSourceId: (explorationId: string | null) => void;
  isEmbeddedMode: boolean;
  isRenderMode: boolean;
  scrollAreaRef?: React.RefObject<HTMLDivElement | null>;
  scrollToTop: () => void;
}

const defaultContextValue = Symbol();

export const LayoutContext = createContext<LayoutContext | typeof defaultContextValue>(
  defaultContextValue,
);

export const useLayoutContext = () => {
  const context = useContext(LayoutContext);
  if (context === defaultContextValue) {
    throw new Error('useLayoutContext must be used within a LayoutContextProvider');
  }
  return context;
};

/** Render mode = headless PDF/PNG capture. Safe outside a provider (returns false). */
export const useIsRenderMode = (): boolean => {
  const context = useContext(LayoutContext);
  return context !== defaultContextValue && context.isRenderMode;
};
